export const readFile = (input: HTMLInputElement, onLoad: (contents: string) => void) => {
    const file = (input.files ?? [])[0];
    if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
            input.value = '';
            const contents = evt?.target?.result || '';

            onLoad(contents.toString());
        }
        reader.onerror = (evt) => {
            alert('Kon dit bestand niet lezen');
        }
    }
}
